import styled from "styled-components";
import { colors } from "../Navbar/Navbar.styled";

export const NavbarElementWrapper = styled.div`
  display: flex;
  align-items: center;

  .nav-link { text-decoration: none; border-radius: .4rem; }
  .nav-link:focus-visible { outline: 3px solid rgba(122, 30, 30, .35); outline-offset: 4px; }
  .nav-link.active span, .nav-link:hover span { color: ${colors.red}; }
  @media (max-width: 1120px) {
    .nav-link { width: 100%; padding: .7rem .25rem; }
  }
`;

export const NavText = styled.span`
  font-size: 0.85rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${colors.dark};
  padding: 0.25rem 0;
  transition: color 0.25s ease;
`;
